export const headerbgColor = "#FFF";
export const homeBGColor = "#e9f3f1";

export const appBackgroundColor = "#DEE4E8";
export const appFontColor = "#515151";

export const whiteColor = "#FFFFFF";
export const whiteHoverColor = "#FAFAFA";
export const whiteActiveColor = "#F1F1F1";

export const primaryColor = "#0059B8";
export const primaryHoverColor = "#0068D7";
export const primaryActiveColor = "#064F9D";

export const secondaryColor = "#DA375F";
export const secondaryHoverColor = "#ED3965";
export const secondaryActiveColor = "#C62C52";

export const newsecondaryColor = '#00BE9A'
export const newsecondaryHoverColor = '#10dbb5'
export const newsecondaryActiveColor = '#10dbb5'

export const inputBackgroundColor = "#fcfcfc";
export const inputBackgroundHoverColor = "#f1f1f1";
export const inputBorderColor = "#DFE3E9";

export const defaultColor = "#ccc";
export const defaultHoverColor = "#ccc";
export const defaultActiveColor = "#ccc";
export const blackColor = "#000";

export const footerBodyColor = "#F5F5F5";
export const footerBGColor = "#e9e9e9";
export const staticBgColor = "#F5F5F5";

export const labelColor = "#33403E";
export const dangerColor = '#E24444'
export const successColor = '#13BD38';
export const infoBGColor = '#ECF4FC';